import Vue from 'vue'
import Vuex from 'vuex'

import { auth } from './modules/auth.module'

Vue.use(Vuex)
const stateDefault = {
  loading: true,
  sincronizando: false,
  extension: false,
  status: false,
  address: ''
}
export default new Vuex.Store({
  state: stateDefault,
  mutations: {
    setLoading (state, status) { state.loading = status },
    setExtension (state, status) { state.extension = status },
    setAddress (state, address) {
      state.address = (!address) ? '' : address
    },
    reset (state) {
      state = stateDefault
    }
  },
  actions: {
    /*
    * conectar con la billetera utilizando tronWeb
    */
    async connectWallet ({ state, commit }) {
      // commit('setLoading', true)
      let count = 1
      return new Promise((resolve) => {
        let ciclo = setInterval(async () => {
          if (!state.sincronizando) {
            state.sincronizando = true
            console.log('conectando con tronWeb')
            const tronWebState = {
              installed: !!window.tronWeb,
              loggedIn: window.tronWeb && window.tronWeb.ready
            }
            if (tronWebState.installed) {
              console.log('tronWeb activo')
              commit('setAddress', window.tronWeb.defaultAddress.base58)
              commit('setExtension', true)
              commit('setLoading', false)
              state.sincronizando = false
              clearInterval(ciclo)
              ciclo = null
              return resolve()
            }
          } else {
            console.log('esperando respuesta')
            if (count === 3) {
              console.log('no fue posible conectar con tronWeb, instalar por defecto')
              commit('setAddress', '')
              commit('setExtension', false)
              commit('setLoading', false)
              state.sincronizando = false
              clearInterval(ciclo)
              ciclo = null
              return resolve()
            }
            count++
          }
        }, 5000)
      })
    },
    async close ({ state, commit, dispatch }) {
      console.log('close')
      // state = stateDefault
      await commit('setLoading', true)
      await commit('setExtension', false)
      await commit('setAddress', '')
      await dispatch('auth/logoutWallet')
    },
    async reset ({ state, commit, dispatch }) {
      await commit('setLoading', true)
      await commit('setExtension', false)
      await commit('setAddress', '')
      await dispatch('auth/reset')
    }
  },
  getters: {
    isLoading: state => {
      return state.loading
    },
    getAddress: state => {
      return state.address
    },
    /* la billetera esta instalada */
    walletIsInstalled: state => state.extension
  },
  modules: {
    auth
  }
})
